import { ConfirmModal } from '@/components';
import { useMessage } from '@/providers';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';
import { useDeleteMinistry } from '../../hooks/ministry';

type Props = {
  deletingId: string | null;
  onClose: () => void;
};

export const DeleteMinistryConfirmModal: FC<Props> = ({
  deletingId,
  onClose,
}) => {
  const { t } = useTranslation();
  const { openMessage } = useMessage();

  const { mutateAsync: deleteMutateAsync } = useDeleteMinistry();

  return (
    <ConfirmModal
      open={deletingId !== null}
      title={t('delete-confirmation')}
      disclaimerText={t('delete-confirmation-disclaimer')}
      onOk={async () => {
        invariant(deletingId, t('unreachable-code'));
        try {
          await deleteMutateAsync(deletingId);
          await Promise.all([
            openMessage('success', t('message-delete-completed')),
            (async () => {
              onClose();
            })(),
          ]);
        } catch {
          await openMessage('error', t('message-delete-failed'));
        }
      }}
      onCancel={onClose}
      skipCheck
    />
  );
};
